import React, { PureComponent } from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import text from './ClientList.page.translation';
import './ClientList.style.less';

class ConfirmRevokeModal extends PureComponent {
  renderTitle = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div>
        <div className="title-container">
          {formatMessage(text.modalRevoke.title)}
        </div>
        <div className="modal-separator" />
      </div>
    );
  };

  renderBody = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    return (
      <div className="body-container">
        {formatMessage(text.modalRevoke.description)}
      </div>
    );
  };

  renderFooter = () => {
    const {
      intl: { formatMessage },
      handleCancel,
      handleRevoke,
      loadingRevoke,
    } = this.props;

    return (
      <div className="footer-container">
        <Button type="default" className="cancel-btn" onClick={handleCancel}>
          {formatMessage(text.modalRevoke.buttonCancel)}
        </Button>
        <Button
          type="danger"
          className="btn"
          onClick={handleRevoke}
          loading={loadingRevoke}
        >
          {formatMessage(text.modalRevoke.buttonRevoke)}
        </Button>
      </div>
    );
  };

  render = () => (
    <Modal
      className="delivery-confirm-revoke-modal"
      width={360}
      bodyStyle={{ padding: '0px' }}
      centered
      title=""
      visible={this.props.visible}
      footer={null}
      closable={false}
      destroyOnClose
    >
      {this.renderTitle()}
      {this.renderBody()}
      {this.renderFooter()}
    </Modal>
  );
}

ConfirmRevokeModal.propTypes = {
  visible: PropTypes.bool,
  intl: PropTypes.object,
  handleCancel: PropTypes.func,
  handleRevoke: PropTypes.func,
  loadingRevoke: PropTypes.bool,
};

export default ConfirmRevokeModal;
